export default __webpack_public_path__ + "static/media/poor.f1072919.svg";